import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getEmailDefault(emailType) {
        return Axios.get(`${baseURL}account/email-default/${emailType}`).then(
            response => response.data.response
        );
    },
    getAppointmentEmailTemplate(formData) {
        return Axios.get(
            `${baseURLci}account/common/appointment/getEmailTemplate`,
            { params: formData }
        ).then(response => response.data.response);
    },
    renderEmailMessage(params) {
        /**
         * 	params example
         *	"business_id": "0000000000000001",
         *  "user_id": "0000000000000004",
         *  "email_type": 10 ,
         *  "client_id": "2589879c-ae6a-11",
         *
         *  "patient_id": [],
         *  "invoice_id": [14d71677-78ab-49],
         *	"estimate_ids": [14d71677-78ab-49],
         *	"return_id": [14d71677-78ab-49],
         *	"payment_id": [e72aef81-2139-4a],
         *
         */
        return Axios.get(`${baseURL}account/render-email-message`, {
            params
        }).then(response => response.data.response);
    }
};
